import React from 'react';

import BaseGenericTemplatesEditor from '~/components/GenericTemplates/GenericTemplatesConfiguration/GenericTemplateBuilder/BaseGenericTemplatesEditor';
import type { TemplateBuilderEditorInnerComponentProps } from '~/components/GenericTemplates/types';

const NotificationGenericTemplatesEditor: React.FC<TemplateBuilderEditorInnerComponentProps> = ({
  disabled,
  suggestions,
}) => {
  return (
    <BaseGenericTemplatesEditor
      titleHeading="Notification Title"
      bodyHeading="Notification Body"
      suggestions={suggestions}
      disabled={disabled}
    />
  );
};

export default NotificationGenericTemplatesEditor;
